const TramIcon = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="24"
      viewBox="0 0 18 24"
      fill="none"
    >
      <path
        d="M0 5C0 3.89543 0.895431 3 2 3H16C17.1046 3 18 3.89543 18 5V11H0V5Z"
        fill="#17171C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 13H0V18C0 19.1046 0.89543 20 2 20H16C17.1046 20 18 19.1046 18 18V13ZM5 16.5C5 17.3284 4.32843 18 3.5 18C2.67157 18 2 17.3284 2 16.5C2 15.6716 2.67157 15 3.5 15C4.32843 15 5 15.6716 5 16.5ZM16 16.5C16 17.3284 15.3284 18 14.5 18C13.6716 18 13 17.3284 13 16.5C13 15.6716 13.6716 15 14.5 15C15.3284 15 16 15.6716 16 16.5Z"
        fill="#17171C"
      />
      <path
        d="M5 3H7L7.58377 1.24868C7.78854 0.634382 7.3313 0 6.68377 0C6.27543 0 5.9129 0.261296 5.78377 0.648683L5 3Z"
        fill="#17171C"
      />
      <path
        d="M11 3H13L13.5838 1.24868C13.7885 0.634382 13.3313 0 12.6838 0C12.2754 0 11.9129 0.261296 11.7838 0.648683L11 3Z"
        fill="#17171C"
      />
      <path
        d="M3 20H5L3.24721 23.5056C3.0957 23.8086 2.786 24 2.44721 24C1.78231 24 1.34986 23.3003 1.64721 22.7056L3 20Z"
        fill="#17171C"
      />
      <path
        d="M13 20H15L16.3528 22.7056C16.6501 23.3003 16.2177 24 15.5528 24C15.214 24 14.9043 23.8086 14.7528 23.5056L13 20Z"
        fill="#17171C"
      />
      <rect x="3" y="21" width="12" height="2" fill="#17171C" />
    </svg>
  )
}

export default TramIcon
